import { Theme } from "../component/navigation/ThemeDropdown";

export default function QueueInsightsIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                <g clipPath="url(#clip0_905_5495)">
                    <path
                        d="M11.9985 23.9969C18.625 23.9969 23.9969 18.625 23.9969 11.9985C23.9969 5.3719 18.625 0 11.9985 0C5.3719 0 0 5.3719 0 11.9985C0 18.625 5.3719 23.9969 11.9985 23.9969Z"
                        fill={
                            theme === "light"
                                ? isSelected
                                    ? "#C6D92D"
                                    : "#D8D8D8"
                                : isSelected
                                  ? "#C6D92D"
                                  : "#7A8690"
                        }
                        style={{
                            transition: "fill 0.3s ease",
                        }}
                    />
                    <path
                        d="M8.47374 9.02328H11.6855V6.35186C11.6855 6.18394 11.5512 6.04961 11.3833 6.04961H4.33381C4.16589 6.04961 4.03156 6.18394 4.03156 6.35186V11.6947C4.03156 11.8626 4.16589 11.9969 4.33381 11.9969H8.16843V9.32553C8.16843 9.15761 8.30277 9.02328 8.47069 9.02328H8.47374Z"
                        fill={
                            theme === "light"
                                ? isSelected
                                    ? "#FFFFFF"
                                    : "#606161"
                                : isSelected
                                  ? "#2D3748"
                                  : "#2D3748"
                        }
                        style={{
                            transition: "fill 0.3s ease",
                        }}
                    />
                    <path
                        d="M12.6106 12H15.8224V9.32858C15.8224 9.16066 15.6881 9.02633 15.5202 9.02633H11.6855V11.6977C11.6855 11.8657 11.5512 12 11.3833 12H8.17148V14.6714C8.17148 14.8393 8.30581 14.9737 8.47373 14.9737H12.3084V12.3023C12.3084 12.1343 12.4427 12 12.6106 12Z"
                        fill={
                            theme === "light"
                                ? isSelected
                                    ? "#FFFFFF"
                                    : "#606161"
                                : isSelected
                                  ? "#2D3748"
                                  : "#2D3748"
                        }
                        style={{
                            transition: "fill 0.3s ease",
                        }}
                    />
                    <path
                        d="M19.6601 12H15.8255V14.6714C15.8255 14.8393 15.6912 14.9737 15.5232 14.9737H12.3114V17.6451C12.3114 17.813 12.4458 17.9473 12.6137 17.9473H19.6632C19.8311 17.9473 19.9654 17.813 19.9654 17.6451V12.3023C19.9654 12.1343 19.8311 12 19.6632 12H19.6601Z"
                        fill={
                            theme === "light"
                                ? isSelected
                                    ? "#FFFFFF"
                                    : "#606161"
                                : isSelected
                                  ? "#2D3748"
                                  : "#2D3748"
                        }
                        style={{
                            transition: "fill 0.3s ease",
                        }}
                    />
                </g>
            </svg>
        </div>
    );
}
